import React from 'react'
import WorkSection from '../components/WorkSection'

const Work = () => {
  return (
    <div>
        <WorkSection/>
    </div>
  )
}

export default Work